<template>
  <v-form
    ref="form"
    v-model="valid"
    :lazy-validation="lazy"
    class="d-flex flex-wrap"
    v-on:submit.prevent
  >
    <v-col md="4" sm="12" xs="12">
      <div
        class="ma-1"
        :height="appearance.height"
        :min-width="appearance.minWidth"
      >
        <v-row no-gutters>
          <v-col>
            <v-file-input
              v-model="cer"
              id="fiel_validator_inline__certificado__file"
              label="Certificado de la FIEL(*.cer)"
              accept="application/x-x509-ca-cert"
              :error-messages="getErrors('cer', 'El Certificado')"
              @change="this.cerReader"
              @focus="(e) => $v.cer.$invalid && this.cerValidar ?  $v.cer.$touch() : {}"
              @blur = "() => this.cerValidar = true"
            ></v-file-input>
          </v-col>
        </v-row>
      </div>
    </v-col>
    <v-col md="4" sm="12" xs="12">
      <div
        class="ma-1"
        :height="appearance.height"
        :min-width="appearance.minWidth"
      >
        <v-row justify="center" no-gutters>
          <v-col>
            <v-file-input
              v-model="key"
              id="fiel_validator_inline__clave_privada__file"
              label="Clave Privada de la FIEL(*.key)"
              accept=".key"
              :error-messages="getErrors('key', 'La Clave Privada')"
              @change="this.keyReader"
              @focus="() => this.$v.key.$invalid && this.keyValidar ? this.$v.key.$touch() : {}"
              @blur = "() => this.keyValidar = true"
            ></v-file-input>
          </v-col>
        </v-row>
      </div>
    </v-col>
    <v-col md="4" sm="12" xs="12">
      <div
        class="ma-1"
        :height="appearance.height"
        :min-width="appearance.minWidth"
      >
        <v-row no-gutters>
          <v-col>
            <v-text-field
              v-model="password"
              id="fiel_validator_inline__password__file"
              :append-icon="showPassword ? icon.eye : icon.eyeOff"
              :type="showPassword ? 'text' : 'password'"
              label="Contraseña de la Clave Privada"
              required
              @click:append="showPassword = !showPassword"
              :error-messages="getErrors('password', 'La Contraseña')"
              @input="this.evaluate"
              @blur="$v.password.$touch()"
            />
          </v-col>
        </v-row>
      </div>
    </v-col>
    <v-col md="8" sm="12" xs="12">
      <div
        class="ma-1"
        :height="appearance.height"
        :min-width="appearance.minWidth"
      >
        <v-row class="text-start" no-gutters>
          <v-col class="mt-2">
            <v-alert text :type="this.alertProperties.type" dense>
              {{ alertProperties.message }}
            </v-alert>
          </v-col>
        </v-row>
      </div>
    </v-col>
    <v-col md="4" sm="12" xs="12">
      <div
        class="ma-1"
        :height="appearance.height"
        :min-width="appearance.minWidth"
      >
        <v-row class="text-center" no-gutters>
          <v-col class="mt-2">
            <v-btn
              color="primary"
              id="fiel_validator_inline__valida_fiel__button"
              :disabled="!canValidate"
              @click="raiseValidation"
              :loading="isValidating"
              >Valida tu FIEL</v-btn
            >
          </v-col>
        </v-row>
      </div>
    </v-col>
  </v-form>
</template>

<script>
import { mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import { required } from 'vuelidate/lib/validators'
import VuelidateHelper from '@/utils/VuelidateHelper'
import { signupActions } from '@/modules/auth/store/signupWizardHelpers'
import {
  fielStorageActions,
  fielStorageData
} from '@/modules/signers/store/fielStorageHelpers'

const mensajeNoEnvioAServidores =
  'La Clave Privada y la Contraseña de tu FIEL no se envían a nuestros servidores.'

export default {
  name: 'FielValidatorInline',
  data() {
    return {
      icon: {
        eye: mdiEyeOutline,
        eyeOff: mdiEyeOffOutline
      },
      cer: null,
      key: null,
      password: '',
      cerBytes: null,
      keyBytes: null,
      showPassword: false,
      canValidate: false,
      valid: false,
      lazy: false,
      appearance: {
        height: 110,
        minWidth: 210
      },
      alertProperties: {
        type: 'info',
        message: mensajeNoEnvioAServidores
      },
      isValidating: false,
      keyValidar:false,
      cerValidar: false
    }
  },
  created() {
    this.vuelidateHelper = new VuelidateHelper(this.$v)
  },
  validations: {
    cer: { required },
    key: { required },
    password: { required }
  },
  computed: {
    ...fielStorageData
  },
  methods: {
    ...signupActions,
    ...fielStorageActions,
    evaluate() {
      if (this.$refs.form.validate()) {
        this.canValidate =
          !this.$v.$invalid && this.cerBytes !== null && this.keyBytes !== null
      }
    },
    getErrors(campo, label = '') {
      return this.vuelidateHelper.getErrors(campo, label)
    },
    raiseValidation() {
      this.onValidation()
    },
    async onValidation() {
      //const fiel = new Fiel(this.cerBytes, this.keyBytes, this.password)
      if (
        this.cer === null ||
        this.cer === undefined ||
        this.key === null ||
        this.key === undefined
      ) {
        this.alertProperties.type = 'error'
        this.alertProperties.message =
          'Es necesario tener un archivo .cer y .key para realizar la validación.'
      }

      this.isValidating = true
      const fielParamaters = {
        csd: this.cerBytes,
        key: this.keyBytes,
        password: this.password,
        csdFile: this.cer,
        rfcToCompare: this.rfcToCompare
      }

      let isValid = await this.validateFiel(fielParamaters)

      if (isValid) {
        this.setDatosFiscales({
          rfc: this.fiel.metadata.rfc,
          razonSocial: this.fiel.metadata.razonSocial
        })
        this.resetForm()

        if(this.onSuccessFiel != null && this.onSuccessFiel instanceof Function){
          this.onSuccessFiel()
        }
      } else {
        this.alertProperties.type = 'error'
        this.alertProperties.message = this.fielErrorMessage
      }

      this.isValidating = false
    },
    cerReader(evt) {
      if (evt === undefined || this.cer === null || this.cer === undefined) {
        this.cerBytes = null
        this.evaluate()
        return
      }

      const reader = new FileReader()
      const that = this
      reader.onload = function(e) {
        that.cerBytes = e.target.result.replace(/^data:.+;base64,/, '')
        that.evaluate()
      }

      reader.readAsDataURL(this.cer)
    },
    keyReader(evt) {
      if (evt === undefined || this.key === null || this.key === undefined) {
        this.keyBytes = null
        this.evaluate()
        return
      }

      const reader = new FileReader()
      const that = this
      reader.onload = function(e) {
        that.keyBytes = e.target.result.replace(/^data:.+;base64,/, '')
        that.evaluate()
      }
      reader.readAsDataURL(this.key)
    },
    resetForm() {
      this.$refs.form.reset()
      this.$v.$reset()
      this.cerBytes = null
      this.keyBytes = null
      this.alertProperties.type = 'info'
      this.cerValidar = false
      this.keyValidar = false
      this.alertProperties.message = mensajeNoEnvioAServidores
    }
  },
  watch: {
    clean: function(val){
      if(val){
        this.resetForm()
        this.cleaned()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.great-number {
  border-radius: 50%;
  padding: 4px 8px;
  height: 24px;
  width: 24px;
  background-color: teal;
  text-align: center;
  color: white;
  font-size: 70%;
  font-weight: bolder;
  margin: 0 auto 3px;
}
</style>
